import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DynamicDialogConfig, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { ThiefProtectionService } from "../../../services/api/thief-protection/thief-protection.service";
import { first } from "rxjs";
import { TextareaModule } from "@openng/optimus-ui/textarea";
import { MessageService } from "@openng/optimus-ui/api";

@Component({
  standalone: true,
  selector: "app-resolve-alert",
  imports: [ReactiveFormsModule, TranslateModule, ButtonComponent, TextareaModule],
  templateUrl: "./resolve-alert.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./resolve-alert.component.scss",
})
export class ResolveAlert implements OnInit {
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef);
  private thiefProtectionService = inject(ThiefProtectionService);
  private message = inject(MessageService);
  private translate = inject(TranslateService);

  public form = new FormGroup({
    resolutionNote: new FormControl("", {
      validators: [Validators.required, Validators.minLength(5), Validators.maxLength(500)],
      nonNullable: true,
    }),
  });
  private alert = this.config.data.alert;

  ngOnInit(): void {
    this.form.markAllAsDirty();
  }

  /**
   * Resolves the alert with the specified resolution note
   */
  public resolveAlert() {
    const formValues = this.form.value;
    if (this.form.valid && this.alert.id && formValues.resolutionNote)
      this.thiefProtectionService
        .resolveThiefProtectionAlert(this.alert.id, formValues.resolutionNote)
        .pipe(first())
        .subscribe({
          next: (success) => {
            if (success) {
              this.ref.close({
                success: true,
              });
              this.message.add({
                key: "global",
                severity: "success",
                summary: this.translate.instant("common.success"),
                detail: this.translate.instant("security_tool.resolve_form.success"),
              });
            }
          },
        });
  }

  /**
   * Closes the dialog
   */
  public closeDialog() {
    this.ref.close();
  }
}
